import { ClipboardList, IdCard, Video, Handshake, BadgeDollarSign } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const STEPS = [
  { icon: ClipboardList, title: "Apply", text: "Tell us about you, your business and the volume you move. Takes about 10 minutes.", color: "from-emerald-500 to-emerald-700" },
  { icon: IdCard, title: "Verify ID", text: "Upload a government photo ID and a selfie holding it. Encrypted and seen only by our team.", color: "from-amber-400 to-orange-500" },
  { icon: Video, title: "Video Interview on Zoom", text: "A friendly face-to-face call so we can get to know you and confirm you're the real deal.", color: "from-purple-500 to-fuchsia-600" },
  { icon: Handshake, title: "Approved & Introduced", text: "Pay your one-time fee in cash, then meet vetted farms in person at our California location.", color: "from-orange-500 to-rose-500" },
  { icon: BadgeDollarSign, title: "We Negotiate Your Price", text: "The farm gives us the lowest tickets because of our consistent volume, and you get that price.", color: "from-emerald-400 via-amber-400 to-purple-500" },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-24 sm:py-32" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <p className="eyebrow text-primary">How it works</p>
        <h2 className="mt-3 text-3xl sm:text-5xl font-bold tracking-tight">Five steps from stranger to trusted buyer.</h2>
      </Reveal>
      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-5">
        {STEPS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.1}>
            <div className="relative h-full rounded-3xl border border-border bg-card p-7 hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300" data-testid={`how-step-${i + 1}`}>
              <span className="absolute top-6 right-6 font-display text-5xl font-extrabold text-muted-foreground/15">0{i + 1}</span>
              <div className={`h-14 w-14 rounded-2xl bg-gradient-to-br ${s.color} grid place-items-center shadow-lg`}>
                <s.icon className="h-7 w-7 text-white" />
              </div>
              <h3 className="mt-6 text-xl font-bold">{s.title}</h3>
              <p className="mt-2 text-muted-foreground leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
